import type { SelectProps } from '@mantine/core'
import { useRef, useState } from 'react'

type TSelectClickToggleProps = Pick<
  SelectProps,
  'dropdownOpened' | 'onDropdownOpen' | 'onDropdownClose' | 'onMouseDown' | 'onClick'
>

/**
 * Spread onto a searchable Select so a click on the open field closes it; Mantine only opens on click, so
 * a phone could never close one. "Open" is read at mousedown: focusing opens it before the click lands.
 */
export const useSelectClickToggle = (): TSelectClickToggleProps => {
  const [dropdownOpened, setDropdownOpened] = useState(false)
  const openedAtPress = useRef(false)

  return {
    dropdownOpened,
    onDropdownOpen: () => setDropdownOpened(true),
    onDropdownClose: () => setDropdownOpened(false),
    onMouseDown: () => {
      openedAtPress.current = dropdownOpened
    },
    onClick: () => {
      if (openedAtPress.current) setDropdownOpened(false)

      openedAtPress.current = false
    },
  }
}
